module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GR-19ab431866bd00115ce4c200a698d54a.png";